import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import PrivateAI from '../components/PrivateAI';

function PrivateAIPage() {
  return (
    <>
      <PageHero
        label="Data Sovereignty"
        title="Stop Renting AI. Start Owning It."
        subtitle="Your data. Your model. Your servers. No API tokens. No data leaving your building."
      />
      <BackButton />
      <PrivateAI />
    </>
  );
}

export default PrivateAIPage;
